import React, { useEffect } from 'react';
import { useFormik } from 'formik';
import { Button, Flex, Typography } from 'antd';
import { useParams } from 'react-router-dom';

import { fields, initialValues, validationSchema } from '../fields';
import { renderField } from '../../../../promocodes/utils/fields';
import {
    useLazyReadRobokassaQuery,
    useUpdateRobokassaMutation,
} from '../../../service/paymentSettings.api';
import { StepTitle } from '../../steps/StepTitle';
import { StepList } from '../../steps/StepList';
import { FORM_WIDTH, formikCommonOptions } from '../../../utils/options';
import { useAppSelector } from '../../../../../../../store';
import { selectShopCurrent } from '../../../../shops/store/shopSlice';

const { Text } = Typography;

export const RobokassaStepConnect = () => {
    const current = useAppSelector(selectShopCurrent);
    const [getRobokassa, { data, isLoading }] = useLazyReadRobokassaQuery();

    const [createRobokassa] = useUpdateRobokassaMutation();

    useEffect(() => {
        getRobokassa(+current.id, true);
    }, [current.id]);
    const onSubmit = async values => {
        const payload = {
            shop_id: +current.id,
            ...values,
        };

        await createRobokassa(payload);
    };

    const formik = useFormik({
        initialValues: { ...data } || initialValues,
        validationSchema,
        onSubmit: onSubmit,
        ...formikCommonOptions,
    });

    return (
        <Flex vertical gap={8}>
            <StepTitle text={'Шаг 2. Предоставление доступа'} />

            <StepList>
                <Text>
                    Для предоставления доступа необходимо указать следующие
                    данные:
                </Text>
            </StepList>

            <Flex vertical style={{ width: FORM_WIDTH }} gap={8}>
                {fields.map(field => (
                    <React.Fragment key={field.name}>
                        {renderField(field, formik)}
                    </React.Fragment>
                ))}
            </Flex>
            <Flex vertical={false} justify={'space-between'}>
                <Button
                    disabled={!formik.isValid || !formik.dirty}
                    onClick={() => onSubmit(formik.values)}
                >
                    Сохранить
                </Button>
            </Flex>
        </Flex>
    );
};
